<template v-if="this.$store.getters.GetBlock.history">
    <div v-if="this.$store.getters.Loaded " id="history" class="uk-container uk-container-center uk-text-center uk-margin-top uk-position-z-index-negative" style="background-image: none;" uk-scrollspy="cls:uk-animation-slide-bottom;">
        <h1 class="uk-heading" v-html="this.$store.getters.GetText.history.title[this.$store.getters.Lang]"></h1>
        <article v-html="this.$store.getters.GetText.history.body[this.$store.getters.Lang]" class="uk-article uk-position-z-index-negative"></article>
        
        <ul uk-accordion>
            <li>
                <a class="uk-accordion-title uk-button uk-button-default" href="#" v-html="this.$store.getters.GetText.history.title_table[this.$store.getters.Lang]"></a>
                <div class="uk-accordion-content">
                    <table class="uk-table uk-table-divider uk-table-hover uk-table-justify uk-align-left">      
                        
                        <tbody v-html="this.$store.getters.GetText.history.tbody[this.$store.getters.Lang]">
                           
                        </tbody>
                       
                    </table>
                </div>
            </li>
        </ul>

    </div>
</template>